import { AnimationClip, BufferGeometry, Group, Object3D, Quaternion, Scene, Vector3 } from "three";
import { IPreloadModelReturnData } from "../components/Model3d/hooks";
import { StaticGeometryWorkerController } from "./StaticGeometryWorkerController";

export const getAnimationClipByName = (clips: AnimationClip[], name: string) => {
    // At times threejs prefixes animation names with 'animation_'. If no 
    // animationClip found try with that animation prefix.
    let action: AnimationClip | null = null
    action = AnimationClip.findByName(clips, name);
    if (action) return action;
    action = AnimationClip.findByName(clips, 'animation_' + name);
    return action;
}

export const getModelPrimitiveGroup = (id: string, scene: Scene) => {
    const modelPrimitive = scene.getObjectByName(`${id}-primitive`) as Group;

    if (!modelPrimitive) {
        console.error('unable to retrieve model primitive: bvh not added')
    }

    return modelPrimitive;
}

const v1 = new Vector3();
const q1 = new Quaternion();
const v2 = new Vector3();

export const applyWorldTransformsToTarget = (a: {source?: Object3D, target: Object3D, updateMatrixWorld?: boolean}) => {
    if (!a.source) return false;
   
    const position = a.source.getWorldPosition(v1);
    const quaternion = a.source.getWorldQuaternion(q1);
    const scale = a.source.getWorldScale(v2)


    a.target.position.copy(position);
    a.target.quaternion.copy(quaternion);
    a.target.scale.copy(scale);
    if (a.updateMatrixWorld) a.target.updateMatrixWorld(true);

    return true;
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateBVHForGeometries = async (worker: any, geometries: BufferGeometry[], id?: string) => {
    for (let i = 0; i < geometries.length; i++) {
        // geometries need to be cloned to avoid corruption of original geometry
        const geo = geometries[i].clone();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (geometries[i] as any).boundsTree = await worker.generate(geo);
        geo.dispose();
        // console.log('BVH ADDED', geometries[i], id)
    }
}



export const preInitialiseWorkerWithArrayBuffers = async (workerController: StaticGeometryWorkerController, modelDataArray: IPreloadModelReturnData[]) => {
    for (let i = 0; i < (modelDataArray ?? []).length; i++) {
        await workerController.createInitialiseWorkerWithGLTFArrayBufferPromise(
            modelDataArray[i].arrayBuffer, modelDataArray[i].url
        ); 
    }
}
